export default "__VITE_ASSET__BOgvvCg6__"